var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { BASE_URL, ORDER_API_PATH, PRODUCT_API_PATH } from './constants';
import { getBusinessDataLink, getPremiumStatusLink } from './utils/links';
export var createOrder = function (instance, data, url) {
    if (url === void 0) { url = BASE_URL; }
    return axios
        .post("" + url + ORDER_API_PATH, data, { headers: { Authorization: instance } })
        .then(function (resp) { return resp.data; });
};
export var createProduct = function (instance, data, url) {
    if (url === void 0) { url = BASE_URL; }
    return axios
        .post("" + url + PRODUCT_API_PATH, data, { headers: { Authorization: instance } })
        .then(function (resp) { return resp.data; });
};
export var getProduct = function (instance, productId, url) {
    if (url === void 0) { url = BASE_URL; }
    return axios
        .get("" + url + PRODUCT_API_PATH + "/" + productId, { headers: { Authorization: instance } })
        .then(function (resp) { return resp.data; });
};
export var updateProduct = function (instance, data, productId, url) {
    if (url === void 0) { url = BASE_URL; }
    return axios
        .put("" + url + PRODUCT_API_PATH + "/" + productId, data, { headers: { Authorization: instance } })
        .then(function (resp) { return resp.data; });
};
export var updateProductCurrencyFromSettings = function (instance, productId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, product, currency;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Promise.all([
                    getProduct(instance, productId),
                    getBusinessData(instance),
                ])];
            case 1:
                _a = _b.sent(), product = _a[0], currency = _a[1].properties.paymentCurrency;
                product.product.currency = currency;
                return [2 /*return*/, updateProduct(instance, product, productId)];
        }
    });
}); };
export var getBusinessData = function (instance) {
    return axios
        .get(getBusinessDataLink(), { headers: { Authorization: instance } })
        .then(function (resp) { return resp.data; });
};
export var getPremiumStatus = function (instance, baseUrl) {
    if (baseUrl === void 0) { baseUrl = BASE_URL; }
    return axios
        .get(getPremiumStatusLink(baseUrl), { headers: { Authorization: instance } })
        .then(function (resp) { return resp.data.canAcceptOnlinePayments; })
        .catch(function () { return true; });
};
export function makeRequestForOrder(instance, productId, url) {
    return __awaiter(this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, createOrder(instance, { productId: productId })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_1 = _a.sent();
                    return [4 /*yield*/, createOrder(instance, { productId: productId }, url)];
                case 3: return [2 /*return*/, _a.sent()];
                case 4: return [2 /*return*/];
            }
        });
    });
}
